import React, { Component } from "react";
import request from "request";
import { apiUrl } from "../util";
import * as cx from "classnames";

class SendToProblemQueueMulti extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comment: "",
      problem: "",
      delete: true,
      isOpen: false,
      removing: false,
    };
  }
  handleChange = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };
  open = e => {
    e.preventDefault();
    this.setState({ isOpen: true });
  };
  handleDelete = e => {
    this.setState({
      delete: !!e.currentTarget.checked,
    });
  };
  highPriority = e => {
    e.preventDefault();

    if (
      window.confirm(
        "Are you sure you want to do this? \n This means we will start checking this URL regularly again."
      )
    ) {
      request.post(
        {
          url: `${apiUrl}/v1/admin/v2/editTrackedUrl`,
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            Authorization: this.props.user.token,
          },
          form: {
            url: this.props.url,
            priority: "normal",
            fromQueue: false,
          },
        },
        (err, res, data) => {
          if (err) {
            return;
          }
          this.setState({
            isOpen: false,
            removing: false,
          });
          if (this.props.callback) {
            this.props.callback();
          } else {
            alert("Done!");
          }
        }
      );
    }
  };
  lowPriority = e => {
    e.preventDefault();

    if (
      window.confirm(
        "Are you sure you want to do this? \nThis means the URL will no longer be checked on a regular basis."
      )
    ) {
      request.post(
        {
          url: `${apiUrl}/v1/admin/v2/editTrackedUrl`,
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            Authorization: this.props.user.token,
          },
          form: {
            url: this.props.url,
            priority: "low",
            fromQueue: true,
          },
        },
        (err, res, data) => {
          if (err) {
            return;
          }
          this.setState({
            isOpen: false,
            removing: false,
          });
          if (this.props.callback) {
            this.props.callback();
          } else {
            alert("Done!");
          }
        }
      );
    }
  };

  sendToQ = e => {
    e.preventDefault();
    this.setState({ removing: true });
    request.post(
      {
        url: `${apiUrl}/v1/admin/v2/queue/problem`,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.props.user.token,
        },
        form: {
          comment: `${this.state.problem} -- ${this.state.comment}`,
          email:
            this.state.problem === "Real test but screenshot looks off" ||
            this.state.problem === "No screenshot"
              ? true
              : false,
          qids: JSON.stringify(this.props.qids),
          deleteQueueItem: this.state.delete,
        },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        this.setState({
          isOpen: false,
          removing: false,
        });
        if (this.props.callback) {
          this.props.callback();
        } else {
          alert("Sent to problem queue!");
        }
      }
    );
  };
  remove = e => {
    e.preventDefault();
    this.setState({ removing: true });
    request.post(
      {
        url: `${apiUrl}/v1/admin/v2/queue/delete`,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.props.user.token,
        },
        form: {
          url: this.props.url,
          qids: JSON.stringify(this.props.qids),
        },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        if (this.props.callback) {
          this.props.callback();
        } else {
          alert("Deleted from queue!");
        }
        this.setState({
          removing: false,
        });
      }
    );
  };
  render() {
    const { isOpen } = this.state;
    const { urlInfo } = this.props;
    return (
      <>
        <div className={this.state.removing ? "o-40" : ""}>
          {!isOpen && (
            <a href="#" onClick={this.open}>
              report a problem
            </a>
          )}
          {isOpen && (
            <form className="db">
              <div>
                <select name="problem" onChange={this.handleChange}>
                  <option value="">--- pick a reason ---</option>
                  <option value="Page not captured properly">
                    Page not captured properly
                  </option>
                  <option value="Real test but screenshot looks off">
                    Real test but screenshot looks off!
                  </option>
                  <option value="No screenshot"> No screenshot </option>
                  <option value="Broken Images / missing images">
                    Broken Images / missing images
                  </option>
                  <option value="Ads / internal promo">
                    Ads / internal promo
                  </option>
                  <option value="Animations / counters">
                    Animations / counters
                  </option>
                  <option value="Cookie banner">Cookie banner</option>
                  <option value="Captcha">Captcha</option>
                  <option value="Chat bot">Chat bot</option>
                  <option value="Issue with video">Issue with video</option>
                  <option value="Not a real test">Not a real test</option>
                  <option value="No visible difference">
                    No visible difference
                  </option>
                  <option value="Promo causes false positive">
                    Promo causes false positive
                  </option>
                  <option value="Survey">Survey</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div>
                <label for={`remove_${this.props.qid}`}>
                  <input
                    type="checkbox"
                    checked={this.state.delete}
                    name="remove"
                    id={`remove_${this.props.qid}`}
                    onChange={this.handleDelete}
                  />{" "}
                  Remove from started/ended/screening queue
                </label>
              </div>
              <textarea onChange={this.handleChange} name="comment" />
              <button style={{ marginLeft: "6px" }} onClick={this.sendToQ}>
                Send
              </button>
            </form>
          )}
        </div>
        <div
          className={cx("mt1", {
            "o-40": this.state.removing,
          })}
        >
          {this.props.qids && this.props.qids.length > 0 && (
            <span className="mr2">
              <a href="#" onClick={this.remove} className="mr2">
                remove from queue
              </a>
              &middot;
            </span>
          )}
        </div>
      </>
    );
  }
}

export default SendToProblemQueueMulti;
